import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_PUBLIC_BASE_URL;

export const getStudentRegistrationRequests = createAsyncThunk(
  "studentRegistration/getStudentRegistrationRequests",
  async ({ search, skip, limit, status, coordinator_id, course_id }, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
        params: {
          search,
          skip,
          limit,
          status,
          coordinator_id,
          course_id
        }
      };

      const response = await axios.get(
        `${BASE_URL}/course-admissions`,
        config
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return rejectWithValue(response.data);
      }
    } catch (err) {
      if (err.message === "Network Error") {
        return rejectWithValue({
          message: "Network Error",
          status: 404,
          statusText: err.code,
        });
      } else {
        return rejectWithValue(err.response?.data || "Unknown error occurred");
      }
    }
  }
);

export const getRequestById = createAsyncThunk(
  "studentRegistration/getRequestById",
  async ({ id }, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      };

      const response = await axios.get(
        `${BASE_URL}/course-admissions/${id}`,
        config
      );

      if (response.status === 200) {
        return response.data;
      } else {
        return rejectWithValue(response.data);
      }
    } catch (err) {
      if (err.message === "Network Error") {
        return rejectWithValue({
          message: "Network Error",
          status: 404,
          statusText: err.code,
        });
      } else {
        return rejectWithValue(err.response?.data || "Unknown error occurred");
      }
    }
  }
);

export const approveOrRejectRequest = createAsyncThunk(
  "studentPayments/approveOrRejectRequest",
  async (formData, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      };

      const body = JSON.stringify(formData);

      const response = await axios.put(
        `${BASE_URL}/course-admissions/approve-or-reject`,
        body,
        config
      );

      if (response.status === 200) {
        return response.data;
      } else {
        return rejectWithValue(response.data);
      }
    } catch (err) {
      if (err.message === "Network Error") {
        return rejectWithValue({
          message: "Network Error",
          status: 404,
          statusText: err.code,
        });
      } else {
        return rejectWithValue(err.response?.data || "Unknown error occurred");
      }
    }
  }
);

export const getStudentRegistrationRequestsByCoordinator = createAsyncThunk(
  "studentRegistration/getStudentRegistrationRequestsByCoordinator",
  async ({ search, skip, limit, status, course_id }, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
        params: {
          search,
          skip,
          limit,
          status,
          course_id
        }
      };

      const response = await axios.get(
        `${BASE_URL}/course-admissions/coordinator`,
        config
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return rejectWithValue(response.data);
      }
    } catch (err) {
      if (err.message === "Network Error") {
        return rejectWithValue({
          message: "Network Error",
          status: 404,
          statusText: err.code,
        });
      } else {
        return rejectWithValue(err.response?.data || "Unknown error occurred");
      }
    }
  }
);

export const clearRequestMessage = () => ({
  type: 'studentRegRequests/clearMessage',
});